<div class="valueBadges" role="group" aria-label="Дополнительные артикулы">
  <span class="valueBadge" *ngFor="let article of articles | async">
    <span class="valueBadgeText">{{ article.article }}</span>
    <button
      type="button"
      class="valueBadgeRemove"
      [attr.aria-label]="'Удалить артикул ' + article.article"
      matTooltip="Удалить артикул"
      (click)="removeArticle(article)"
    >
      <mat-icon>close</mat-icon>
    </button>
  </span>
  <button
    type="button"
    class="valueBadgeAdd"
    aria-label="Добавить дополнительный артикул"
    (click)="addArticle()"
  >
    <mat-icon>add</mat-icon>Добавить
  </button>
</div>
